// Login — generic, branded entry. Single Google sign-in; the backend (allauth)
// runs the OAuth + the invite-only allowlist.
import { BRAND, Mark } from "../brand.jsx";

export default function Login() {
  return (
    <div className="login">
      <div className="login__card">
        <div className="login__mark"><Mark size={28} /></div>
        <h1 className="login__name">{BRAND.name}</h1>
        <p className="login__tag">{BRAND.tagline}</p>
        <p className="login__blurb">{BRAND.blurb}</p>
        <div className="login__features">
          {BRAND.features.map((f) => <span key={f} className="login__feat">{f}</span>)}
        </div>
        <a className="btn-google" href="/accounts/google/login/">
          <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
            <path fill="#4285F4" d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844a4.14 4.14 0 0 1-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.615z" />
            <path fill="#34A853" d="M9 18c2.43 0 4.467-.806 5.956-2.184l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18z" />
            <path fill="#FBBC05" d="M3.964 10.706A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.706V4.962H.957A8.997 8.997 0 0 0 0 9c0 1.452.348 2.827.957 4.038l3.007-2.332z" />
            <path fill="#EA4335" d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.962L3.964 7.294C4.672 5.167 6.656 3.58 9 3.58z" />
          </svg>
          Sign in with Google
        </a>
        <p className="login__note">Invite-only access</p>
      </div>
    </div>
  );
}
